import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class SuspendUserModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    username: PropTypes.string,
    onClose: PropTypes.func,
    onSuspend: PropTypes.func,
    error: PropTypes.bool
  }

  onClose = () => {
    this.props.onClose();
  }

  onSuspend = () => {
    this.props.onSuspend();
  }

  renderSuspendDialog = () => {
    const { username } = this.props;

    return (
      <React.Fragment>
        <p className='suspend-username'>Suspend {username}</p>

        <p>This user will no longer be able to use the SiteOne system. You should reassign all open responsibilities of this user to another user.</p>

        <div className='suspend-group-btn'>
          <button className='btn btn-primary btn-siteone-default' onClick={this.onClose}>Cancel</button>
          <button className='btn btn-siteone btn-siteone-danger' onClick={this.onSuspend}>Suspend</button>
        </div>
      </React.Fragment>
    );
  }

  renderErrorDialog = () => {
    return (
      <React.Fragment>
        <p className='suspend-username'>
          <i className='glyphicon glyphicon-info-sign' style={{color: 'red', marginRight: 5, top: 4, fontSize: 20}} />Error
        </p>

        <p>You need to unassign this user from their projects before suspending them.</p>

        <div className='suspend-group-btn'>
          <button className='btn btn-primary btn-siteone-default' onClick={this.onClose}>OK</button>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { isOpen, error } = this.props;

    return (
      <Modal
        show={isOpen}
        dialogClassName='suspend-user-modal'
        backdrop='static'
        container={this}
        id='suspend-modal'
      >
        <Modal.Body>
          {error ? this.renderErrorDialog() : this.renderSuspendDialog()}
        </Modal.Body>
      </Modal>
    );
  }
}

export default SuspendUserModal;



// WEBPACK FOOTER //
// ./src/User/Components/suspend-user.js